import { lazy } from "react"
import Organization from "../../views/pages/logistic/Organization"
const Quantitywarehouses = lazy(() => import('../../views/pages/logistic/Quantitywarehouse'))
const Movements = lazy(() => import('../../views/pages/logistic/Movements'))
const OrganizationManager = lazy(() => import('../../views/pages/logistic/component/OrganizationManager'))
const PricePlu = lazy(() => import('../../views/pages/quick-action/PricePlu'))
const QuantityCategories = lazy(() => import('../../views/pages/logistic/component/QuantityCategories'))

const LogisticaRoutes = [
    {
        element: <Quantitywarehouses />,
        path: '/quantity-warehouses'
    },
    {
        element: <Movements />,
        path: '/flow-warehouse'
    },
    {
        element: <Organization />,
        path: '/organization'
    },
    {
        element: <OrganizationManager />,
        path: '/organization/:id'
    },
    {
        element: <Quantitywarehouses />,
        path: '/quantity-warehouse-shop/:id'

    },
    {
        element: <Movements />,
        path: '/flow-warehouse-shop/:id'

    },
    {
        element: <PricePlu />,
        path: '/load-price-plu/:id'

    },
    {
        element: <QuantityCategories />,
        path: 'quantity-categories'
    }
]
export default LogisticaRoutes